export const defaultAccordionOptions = {
    closeOthers: false,
};
export function toggleAccordion(evt, options) {
    // if (!(evt.target instanceof HTMLElement)) return;
    if (!(evt.target instanceof Element))
        return;
    const btn = evt.target.closest('.btn-accordion-dropdown');
    if (!btn || !(btn instanceof HTMLElement))
        return;
    // const btn = evt.target as HTMLElement;
    const el = btn?.parentElement?.querySelector('.accordion-dropdown') ?? null;
    const opts = { ...defaultAccordionOptions, ...options };
    if (!el)
        return;
    console.log('Toggling accordion dropdown', btn, el, opts);
    if (btn.classList.contains('expanded')) {
        el.classList.add('hidden');
        btn.classList.remove('expanded');
        btn.setAttribute('aria-expanded', 'false');
    }
    else {
        el.classList.remove('hidden');
        btn.classList.add('expanded');
        btn.setAttribute('aria-expanded', 'true');
        if (opts.closeOthers) {
            btn?.parentElement?.parentElement?.querySelectorAll('.btn-accordion-dropdown').forEach((otherBtn) => {
                if (!btn.isEqualNode(otherBtn)) {
                    otherBtn?.classList.remove('expanded');
                    if (otherBtn instanceof HTMLElement)
                        otherBtn.setAttribute('aria-expanded', 'false');
                    const otherEl = otherBtn.nextElementSibling;
                    if (otherEl && otherEl.classList.contains('accordion-dropdown')) {
                        otherEl.classList.add('hidden');
                    }
                }
            });
        }
    }
    return;
}
